import { createClient } from 'urql';

export const gqlClient = createClient({
    url: window.config.REACT_APP_DIRECTUS_URI! + 'graphql',
});
